<template>
  <div>
    <vue-tabs @tab-change="handleTabChange" centered>
      <v-tab v-for="item in submenu" :key="item.name" :title="item.name"></v-tab>
      <v-tab id="hej" title="Hantera"></v-tab>
    </vue-tabs>
    
    <!--
    <select v-model="roomId" style="margin-bottom:15px;">
      <option :value.number="0">Alla rum</option>
      <option v-for="room in rooms" v-if="room.name.length" :value="room.id">{{ room.name }}</option>
    </select>-->
    
    <div v-if="!showSettings">
      
      <div v-for="room in rooms">
        
        <div class="bootstrap-wrapper" v-if="getNodes.filter(node => node.roomId == room.id).length">
          
          <div @click="gotToRoom(room.id)" v-if="room.name && !roomId" class="roomtitle">{{ room.name }}</div>

          <div class="container" style="padding:0px;margin:0px;padding-left:12px;">
            <div class="row">
              <div class="col-md-3" v-for="node in getNodes.filter(node => node.roomId == room.id)" v-if="room.show" style="margin-bottom:15px;">
                <div style="border:1px solid #e8e8e8;border-radius:3px;">
                  <div style="min-height:65px;padding:8px;display:flex;justify-content:center;flex-direction:column;">
                    
                    <div class="row" style="padding:0px;margin:0px;text-align:center;">
                      
                      <div :class="[(capsForNode(node) > 1 ? 'col-md-6' : 'col-md-12')]" v-for="cap in node.capabilities" v-if="cap in $root.capabilities" style="margin-bottom:4px;padding:0px;">
                        <capability-view :nodeId="node.id" :events="node.lastEvents" :capabilities="[cap]"></capability-view>
                      </div>
                    </div>
                  </div>
                  <div class="title" @click="enhet(node.id)">
                    <div>{{ trim(node.name || 'Inget namn', 20) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>

      <info-view v-if="!getNodes.length">
        <img src="../assets/nexa/lightbulb.png" style="margin-bottom:2em;">
        <h3>Inga enheter tillagda än</h3>
        Det verkar inte som om du har lagt till några enheter i denna kategorin än, du kan göra detta genom att trycka på knappen här nedanför.
        <button class="blue" @click="add" style="margin-top:2em;">Lägg till enhet</button>
      </info-view>
    </div>
        
    <!-- Alternativ -->
    <div v-if="showSettings">
      <p class="descr">Här kan du hitta alternativ till enheterna som rör hur de visas och annat smått och gott. Ändringarna börjar gälla direkt och du behöver inte ladda om sidan. <span style="color:red;text-decoration:underline;">Du lägger till nya enheter genom våra appar till antingen iOS eller Android.</span></p>
      
      <table>
        <tbody>
          <!--<tr>
            <td @click="add">Lägg till en ny enhet</td>
            <td align="right">&rarr;</td>
          </tr>
          
          <tr>
            <td @click="exclude">Exkludera Z-Wave enhet</td>
            <td align="right">&rarr;</td>
          </tr>-->
          
          <tr class="nohover">
            <td></td><td></td>
          </tr>

          <tr class="nohover">
            <td>Visa dolda enheter</td>
            <td align="right">
              <input :disabled="saving" type="checkbox" v-model="showHiddenNodes" @change="toggleSetting('showHiddenNodes')">
            </td>
          </tr>

          <tr class="nohover">
            <td>Dölj enheter utan värde</td>
            <td align="right">
              <input :disabled="saving" type="checkbox" v-model="hideNodesWithoutValue" @change="toggleSetting('hideNodesWithoutValue')">
            </td>
          </tr>
        </tbody>
      </table>
      
    </div>

  </div>
</template>

<style scoped>
  .title {
    border-top:1px solid #f1f1f1;
    background: #fafafa;
    padding:8px;
    text-align:center;
  }
  
  .roomtitle {
    cursor:pointer;
    border-bottom:1px solid #f7f7f7;
    padding:8px;
    margin-bottom:14px;
    font-weight:bold;
    text-align:center;
  }
</style>

<script>
  import { HTTP } from '../http.js'
  import { VueTabs, VTab } from 'vue-nav-tabs'
  import 'vue-nav-tabs/themes/paper.css'
  import capabilityView from './views/capability'
  import infoView from './views/infoView'
  
  export default {
    name: 'HelloWorld',
    components: {
      VueTabs,
      VTab,
      capabilityView,
      infoView
    },
    data () {
      return {
        nodes: [],
        filterCaps: [],
        activeIndex: 0,
        saving: false,
        showSettings: false,
        hideNodesWithoutValue: false,
        showHiddenNodes: false,
        roomId: 0
      }
    },
    created () {
      this.filterCaps = this.submenu[0].capabilities

      if ('web' in this.$root.data.usersettings) {
        this.hideNodesWithoutValue = this.$root.data.usersettings.web.hideNodesWithoutValue || false
        this.showHiddenNodes = this.$root.data.usersettings.web.showHiddenNodes || false
        console.log(this.$root.data.usersettings.web)
      }
    },
    methods: {
      toggleSetting (name) {
        this.saving = true
                
        if (!('web' in this.$root.data.usersettings)) {
          this.$root.data.usersettings.web = {}
        }
        
        this.$root.data.usersettings.web[name] = this[name]
        
        HTTP.post('usersettings', this.usersettings)
        .then(res => res.data)
        .then(json => this.saving = false)
      },

      /* När en tab ändras */
      handleTabChange (tabIndex, newTab, oldTab) {        
        // Man ska inte kunna välja den sista
        if (!('id' in newTab.$options.propsData)) {
          this.showSettings = false
          const item = this.submenu[tabIndex]
          this.filterCaps = item.capabilities
          this.activeIndex = tabIndex
        } else {
          this.showSettings = true
        }
      },

      enhet (id) {
        this.$router.push({
          name: 'enhet',
          params: {
            id: id
          }
        })
      },

      add () {
        this.$router.push({
          name: 'nyenhet'
        })
      },

      exclude () {
        this.$router.push({
          name: 'remove_zwave'
        })
      },

      theStyle (value) {
        //const age = 'time' in value ? ((new Date() - new Date(value.time)) / 1000) : 100000
        return {
          'font-weight': ('fresh' in value && value.fresh ? 'bold' : '100')
        }
      },

      findOne (haystack, arr) {
        return arr.some(function (v) {
          return haystack.indexOf(v) >= 0
        })
      },
      
      capsForNode (node) {
        const c = node.capabilities.filter(cap => {
          return cap in this.$root.capabilities && cap in node.lastEvents
        })
        
        return c.length
      },
      
      translateType (type) {
        switch (type) {
          case 'ZWave': return 'Z-Wave'; break;
          case 'NexaTransmitter': return 'NEXA'; break;
          case 'NexaSwitch': return 'NEXA'; break;
          case 'GarvanAlarm': return 'Brandvarnare'; break;
        }
        return type
      },
      
      trim (string, length) {
        return string.length > length ? string.substr(0, length) + '...' : string
      },
      
      gotToRoom (roomId) {
        this.$router.push({
          name: 'rum_detaljer',
          params: {
            id: roomId
          }
        })
      }
    },

    computed: {
      submenu () {
        const level = require('../levels')
        return level
      },

      usersettings () {
        return this.$root.data.usersettings
      },
      
      rooms () {
        return this.$root.data.rooms.map(room => {
          room.show = true
          return room
        })
      },
      
      getNodes () {
        return this.$root.data.nodes.filter(node => {
          return node.capabilities.some(v => this.filterCaps.includes(v))
        }).filter(node => {
          if (this.usersettings && 'web' in this.usersettings) {
            if ('hideNodesWithoutValue' in this.usersettings.web) {
              if (this.usersettings.web.hideNodesWithoutValue && Object.keys(node.lastEvents).length === 0) {
                return false
              }
            }
  
            if ('showHiddenNodes' in this.usersettings.web) {
              if (node.hideInApp && !this.usersettings.web.showHiddenNodes) {
                return false
              } else {
                return true
              }
            } else {
              return !node.hideInApp
            }
          }
          
          return node
        }).filter(node => {
          if (this.roomId !== 0) {
            if (node.roomId !== this.roomId)
              return false
          }
          
          return true
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/enheter.vue